/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cube-solid': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M256.002 242.913l210.412-121.43L256.002 0 45.586 121.483zM240.949 268.986L30.534 147.557v242.96L240.949 512zM271.056 268.986V512l210.41-121.483v-242.96z"/>'
  }
})
